import { Link } from "react-router-dom";
import { useContent } from "../lib/content";
import { SEO } from "../components/SEO";

export default function Legal() {
  const c = useContent("legal");
  return (
    <div data-testid="page-legal" className="py-20 md:py-28">
      <SEO path="/mentions-legales" title="Mentions légales — ECO-GEST PATRIMOINE" description="Mentions légales du site ecogest-patrimoine.fr — éditeur, hébergeur, propriété intellectuelle, responsabilité." />
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <p className="overline mb-4"><span className="red-dot" />{c.hero_kicker}</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-8">{c.hero_title}</h1>

        {c.intro && (
          <p className="text-gray-600 leading-relaxed mb-12">{c.intro}</p>
        )}

        <div className="space-y-10">
          {(c.sections || []).map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-lg md:text-xl font-bold tracking-tight mb-3 pb-2 border-b border-gray-200">
                {s.title}
              </h2>
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>

        {c.last_update && (
          <p className="mt-12 text-xs uppercase tracking-[0.2em] text-gray-400">{c.last_update}</p>
        )}

        <div className="mt-12 flex flex-wrap gap-6 text-sm">
          <Link to="/" className="uppercase tracking-wide border-b border-[#E60000] pb-1 hover:text-[#E60000]" data-testid="legal-back-home">Retour à l'accueil</Link>
          <Link to="/confidentialite" className="uppercase tracking-wide text-gray-600 hover:text-[#E60000]" data-testid="legal-to-privacy">Politique de confidentialité</Link>
        </div>
      </div>
    </div>
  );
}
